<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`"></div>
			<div class="container">
				<div class="nav">
					<a-breadcrumb separator=">">
						<a-breadcrumb-item>
							<router-link :to="{path:'/',query:{menuPosition:'1481846823343697922'}}">首页</router-link>
						</a-breadcrumb-item>
						<a-breadcrumb-item>
							<router-link :to="{path:'/news/list',query:{homeMenuFirstId:'1481897579094593538',menuPosition:'1481897632014127105',newsType:'1482881267445805057'}}">新闻列表</router-link>
						</a-breadcrumb-item>
						<a-breadcrumb-item>
							<router-link to="#">{{info.news.newsTitle}}</router-link>
						</a-breadcrumb-item>
					</a-breadcrumb>
					<div class="reback" @click="reback">
						返回
						<a-icon type="rollback" />
					</div>
				</div>
				<div class="main">
					<a-spin :spinning="loading">
						<div class="title">{{info.news.newsTitle}}</div>
						<div class="time">发布时间：{{info.news.releaseTime}}</div>
						<div class="dliver"></div>
						<div class="content" v-if="info.news.pcDetails!=null" v-html="info.news.pcDetails"></div>
						<div class="content" v-else>
							<a-empty style="padding:50px;" description="暂无数据" />
						</div>
					</a-spin>
					<div v-if="info.NewsEnclosure!=''">
						<div class="font-18 text-bold">附件</div>
						<div class="margin-top-15">
							<a class="margin-bottom-15" :href="filePath+item.enclosureUrl" v-for="(item,index) in info.NewsEnclosure" :key="index">{{item.enclosureName}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id:"",
				info:{},
				loading:true,
				headBg: "",
				filePath:this.$api.baseUrl+this.$api.imgPath,
			}
		},
		created() {
			this.id = this.$route.query.newsId;
			this.getNewsInfo();
			this.getHeadBg();
		},
		methods: {
			getHeadBg(){
				this.$request({
					url:this.$api.public.getBanner,
					data:{
						menuPosition:2,
						type:1
					}
				}).then((res)=>{
					this.headBg = this.$api.baseUrl+this.$api.imgPath+res.data.result[0].pcImageUrl;
				})
			},
			// 获取新闻详情
			getNewsInfo(){
				this.$request({
					url:this.$api.news.getNewsInfo,
					data:{id:this.id}
				}).then((res)=>{
					this.info = res.data.result;
					this.loading = false;
				})
			},
			// 返回上一页
			reback() {
				window.history.go(-1);
			},
			onChange() {

			}
		}
	}
</script>

<style scoped>
	.bg-gray {
		background: #F6F7FC;
	}
	
	.title{
		text-align: center;
		font-size: 24px;
		font-weight: bold;
	}
	
	.nav {
		width: 1200px;
		height: 100px;
		background: #FFFFFF;
		opacity: 1;
		border-radius: 8px;
		margin-top: -50px;
		padding: 40px;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 115px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.main {
		margin-top: 15px;
		padding:40px;
		background-color: white;
		border-radius: 8px;
		margin-bottom: 30px;
	}

	.reback {
		cursor: pointer;
	}

	.reback:hover {
		color: #13B8EE;
	}

	.time{
		margin-top: 15px;
		color: #999;
		text-align: center;
	}
	
	.dliver{
		width: 100%;
		height: 2px;
		background: #999999;
		margin-top: 15px;
		margin-bottom: 30px;
		opacity: 0.2;
		border-radius: 0px;
	}

	.clear {
		clear: both;
	}
</style>



// WEBPACK FOOTER //
// src/pages/news/info.vue